import type { ISavedDocument, IUser } from 'findef'

export type FindexUser = ISavedDocument<IUser, string>

export enum EUserPortalMode {
  DEFAULT = 0,
  IR_ADMIN = 1,
  __COUNT
}
